import { AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { MatSort } from '@angular/material/sort';
import { combineLatest, Subscription } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { ApplicationService } from 'services/application/application.service';
import { DialogService } from 'services/dialogs/dialogs.service';
import { ErrorService } from 'services/error/error.service';
import { ScreenSizeService } from 'services/screensize/screensize.service';
import { SplashService } from 'services/splash/splash.service';
import { UserService } from 'services/user/user.service';
import { DatePipe } from '@angular/common';
import { TitleCasePipe } from 'pipes/titlecase.pipe';
var OutOfOfficeComponent = /** @class */ (function () {
    function OutOfOfficeComponent(appSvc, datePipe, dialogSvc, errorSvc, screeenSizeSvc, splashSvc, titleCasePipe, userSvc) {
        this.appSvc = appSvc;
        this.datePipe = datePipe;
        this.dialogSvc = dialogSvc;
        this.errorSvc = errorSvc;
        this.screeenSizeSvc = screeenSizeSvc;
        this.splashSvc = splashSvc;
        this.titleCasePipe = titleCasePipe;
        this.userSvc = userSvc;
        this.__subrelease = new Subscription();
        this.AllHeaders = [
            'DesigneeLastName',
            'DesigneeFirstName',
            'DesigneeLocalJobTitle',
            'Categories',
            'DateBegin',
            'DateEnd',
            'Active',
            'Actions',
        ];
    }
    Object.defineProperty(OutOfOfficeComponent.prototype, "_subrelease", {
        get: function () {
            return this.__subrelease;
        },
        set: function (_newsub) {
            this.__subrelease.add(_newsub);
        },
        enumerable: true,
        configurable: true
    });
    OutOfOfficeComponent.prototype.ngOnDestroy = function () {
        this.__subrelease.unsubscribe();
    };
    OutOfOfficeComponent.prototype.ngAfterViewInit = function () {
        if (this.sorter) {
            this.OutOfOfficeSettingsSource.sort = this.sorter;
        }
    };
    OutOfOfficeComponent.prototype.ngOnInit = function () {
        var self = this;
        self.ActiveOutOfOffice = false;
        self.AvailableCategories = [];
        self.OutOfOfficeSettings = [];
        self.OutOfOfficeSettingsSource = new MatTableDataSource([{}]);
        self.SmallDisplay = false;
        self.Subordinates = [];
        self.User = null;
        self.ViewReady = false;
        // Monitor for screen size alerts
        self._subrelease = self.screeenSizeSvc.ScreenSizeSub.subscribe(function (_size) {
            self.SmallDisplay = _size.IsSmallSize;
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
        });
        // Get what needs to be loaded for this component.
        // Wait for the first non-null UserInfo object, to begin component life cycle.
        self._subrelease = self.userSvc.UserSubject.pipe(first(function (_u) { return _u && !!_u.AuthToken; })).subscribe(function (_user) {
            self.User = _user;
            // Set up constant user monitoring
            self._subrelease = self.userSvc.UserSubject.subscribe(function (user) {
                self.User = user;
            }, function (error) { return self.errorSvc.HandleServiceError(error); });
            // Grab the information needed for the component
            self._subrelease = combineLatest(self.appSvc.GetOutOfOfficeSettingsByCabinetSAPID(self.User.AuthToken, self.User.CurrentRole, self.User.SAPID), self.appSvc.GetAllSubordinates(self.User.AuthToken, self.User.CurrentRole, self.User.SAPID), self.appSvc.GetAllCategories())
                .pipe(map(function (_packet) {
                return {
                    Settings: _packet[0],
                    Subordinates: _packet[1],
                    Categories: _packet[2],
                };
            }))
                .subscribe(function (packet) {
                self.Subordinates = packet.Subordinates || [];
                self.AvailableCategories = (packet.Categories || []).filter(function (c) { return c.CabinetMember && c.CabinetMember.SAPID === self.User.SAPID; });
                self.UpdateSettings(packet.Settings || []);
                // The page is ready for viewing.
                self.ViewReady = true;
            }, function (error) { return self.errorSvc.HandleServiceError(error); });
        }, function (error) { return self.errorSvc.HandleServiceError(error); });
    };
    // #region Deactivate Designee
    OutOfOfficeComponent.prototype.DeactivateDesignee = function (des, toRemove) {
        var self = this;
        if (!des) {
            return;
        }
        toRemove = toRemove || false;
        // Get a confirmation.
        self.dialogSvc
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You are about to " + (toRemove ? 'remove' : 'deactivate') + " the following \"Out of Office\" designation:<br /><br />" +
                ("<strong>Designee: </strong>" + self.titleCasePipe.transform(des.DesigneeFirstName) + " ") +
                (self.titleCasePipe.transform(des.DesigneeLastName) + " (" + des.DesigneeLocalJobTitle + ")<br />") +
                ("<strong>Begin Date: </strong>" + self.datePipe.transform(des.DateBegin, 'M/d/yy') + "<br />") +
                ("<strong>End Date: </strong>" + (des.DateEnd != null ? self.datePipe.transform(des.DateEnd, 'M/d/yy') : 'N/A (Open)')) +
                ("<br /><strong>Categories:</strong><br />" + des.Categories.reduce(function (prev, cur) { return prev + cur.CategoryDescription + '<br />'; }, '') + "<br /><br />") +
                ((toRemove
                    ? '<strong>This action will remove the "Out of Office" designation.</strong>' +
                        ' If you wish to reinstate this designation in the future, you will need to recreate the designation.'
                    : 'This action will only deactivate the "Out of Office" designation. You may return to reactivate ' +
                        'this designation at a later date if you wish.') + " Once " + (toRemove ? 'removed' : 'deactivated') + ", the ") +
                "designated individual shown above will no longer be able to view or act upon requests upon " +
                "your behalf. Are you sure you wish to continue?",
            OKText: "Yes - " + (toRemove ? 'Remove' : 'Deactivate'),
            CancelText: 'No - Cancel',
            width: '700px',
            height: '500px',
        })
            .subscribe(function (result) {
            if (!result) {
                return;
            }
            // User opted to continue. Deactivate or remove as needed
            self.appSvc
                .DeactivateOutOfOfficeSetting(self.User.AuthToken, self.User.CurrentRole, des.OutOfOfficeSettingID, toRemove)
                .subscribe(function (settings) {
                // Splash success.
                self.splashSvc.SnackbarSuccess("Out Of Office Designation " + (toRemove ? 'Removed' : 'Deactivated') + " Successfully.");
                // Update the data sources
                self.UpdateSettings(settings || []);
            }, function (error) { return self.errorSvc.HandleServiceError(error); });
        });
    };
    // #endregion
    // #region Edit Designee
    OutOfOfficeComponent.prototype.EditDesignee = function (des) {
        var self = this;
        if (!des) {
            return;
        }
        self.dialogSvc
            .OpenOOODesigneeSearchDialog({
            TitleText: 'Out Of Office Designee Search',
            MessageText: "",
            OKText: 'Update Designation',
            CancelText: 'Cancel',
            width: '900px',
            height: '600px',
            Categories: self.AvailableCategories,
            Subordinates: self.Subordinates,
            InitialValues: des,
        })
            .subscribe(function (result) {
            if (result != null) {
                // User selected a person. Send the request off to the server.
                self.appSvc
                    .UpsertOutOfOfficeSetting(self.User.AuthToken, self.User.CurrentRole, des.OutOfOfficeSettingID, des.CabinetSAPID, result.User.SAPID, result.DateBegin, result.DateEnd, result.Active, result.Categories.map(function (c) { return c.CategoryID; }))
                    .subscribe(function (settings) {
                    // Splash success.
                    self.splashSvc.SnackbarSuccess("Out Of Office Setting Updated Successfully.");
                    // Update the out of office settings.
                    self.UpdateSettings(settings || []);
                }, function (error) { return self.errorSvc.HandleServiceError(error); });
            }
        });
    };
    // #endregion
    // #region Reactivate Designee
    OutOfOfficeComponent.prototype.ReactivateDesignee = function (des) {
        var self = this;
        if (!des) {
            return;
        }
        // Get a confirmation.
        self.dialogSvc
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You are about to reactivate the following \"Out of Office\" designation:<br /><br />" +
                ("<strong>Designee: </strong>" + self.titleCasePipe.transform(des.DesigneeFirstName) + " ") +
                (self.titleCasePipe.transform(des.DesigneeLastName) + " (" + des.DesigneeLocalJobTitle + ")<br />") +
                ("<strong>Begin Date: </strong>" + self.datePipe.transform(des.DateBegin, 'M/d/yy') + "<br />") +
                ("<strong>End Date: </strong>" + (des.DateEnd != null ? self.datePipe.transform(des.DateEnd, 'M/d/yy') : 'N/A (Open)')) +
                ("<br /><strong>Categories:</strong><br />" + des.Categories.reduce(function (prev, cur) { return prev + cur.CategoryDescription + '<br />'; }, '') + "<br /><br />Once reactivated, the ") +
                "designated individual shown above will be able to view or act upon requests upon " +
                "your behalf during the indicated date range. Are you sure you wish to continue?",
            OKText: "Yes - Reactivate",
            CancelText: 'No - Cancel',
            width: '700px',
            height: '500px',
        })
            .subscribe(function (result) {
            if (!result) {
                return;
            }
            // User opted to continue. Reactivate
            self.appSvc
                .ReactivateOutOfOfficeSetting(self.User.AuthToken, self.User.CurrentRole, des.OutOfOfficeSettingID)
                .subscribe(function (settings) {
                // Splash success.
                self.splashSvc.SnackbarSuccess("Out Of Office Designation Reactivated Successfully.");
                // Update the data sources
                self.UpdateSettings(settings || []);
            }, function (error) { return self.errorSvc.HandleServiceError(error); });
        });
    };
    // #endregion
    // #region Show Out Of Office Form
    OutOfOfficeComponent.prototype.ShowOutOfOfficeForm = function () {
        var self = this;
        self.dialogSvc
            .OpenOOODesigneeSearchDialog({
            TitleText: 'Out Of Office Designee Search',
            MessageText: "",
            OKText: 'Create Designation',
            CancelText: 'Cancel',
            width: '900px',
            height: '600px',
            Categories: self.AvailableCategories,
            Subordinates: self.Subordinates,
        })
            .subscribe(function (result) {
            if (result != null) {
                // User selected a person. Send the request off to the server.
                self.appSvc
                    .UpsertOutOfOfficeSetting(self.User.AuthToken, self.User.CurrentRole, null, self.User.SAPID, result.User.SAPID, result.DateBegin, result.DateEnd, result.Active, result.Categories.map(function (c) { return c.CategoryID; }))
                    .subscribe(function (settings) {
                    // Splash success.
                    self.splashSvc.SnackbarSuccess("Out Of Office Setting Added Successfully.");
                    // Update the out of office settings.
                    self.UpdateSettings(settings || []);
                }, function (error) { return self.errorSvc.HandleServiceError(error); });
            }
        });
    };
    // #endregion
    // #region Update Settings
    OutOfOfficeComponent.prototype.UpdateSettings = function (settings) {
        var self = this;
        var Now = new Date();
        self.OutOfOfficeSettings = settings || [];
        self.NoData = !self.OutOfOfficeSettings.length;
        self.ActiveOutOfOffice =
            self.OutOfOfficeSettings.findIndex(function (s) {
                return s.Active === true && s.DateBegin <= Now && (!s.DateEnd || s.DateEnd >= Now);
            }) >= 0;
        self.OutOfOfficeSettingsSource.data = self.NoData ? [{}] : self.OutOfOfficeSettings;
        self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
        self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
    };
    return OutOfOfficeComponent;
}());
export { OutOfOfficeComponent };
